'use strict';

require('core-js/client/shim');